import { searchLocations } from "../../requests/locations";
import { LocationInput } from "qjumpers.common.ui";
import React from "react";
const LocationInputWrapper = (props) => {
  return (
    <LocationInput {...props} searchLocations={searchLocations}/>
  )
};
export default LocationInputWrapper;